import React, { useState } from 'react';
import { Button, useNotify } from 'react-admin';
import MBackdrop from '../../../components/controls/MBackdrop';
import AutocompleteConfirm from './AutocompleteConfirm';
import type { IData } from '../../../types';

interface UnmapAllButonProps {
    params: IData;
    dataProvider: IData;
    selectedIds: (string | number)[];
    reloadPage: () => void;
}

const UnmapAllButon = ({ params, dataProvider, selectedIds, reloadPage }: UnmapAllButonProps) => {
    const notify = useNotify();

    const [state, setState] = useState({
        selectedIds: [] as (string | number)[],
        unmap_isOpen: false,
        unmap_sync_isLoading: false
    });

    const handleClose = () => {
        setState((prev) => ({ ...prev, unmap_isOpen: false }));
    };

    const confirmUnmapAll = () => {
        if (selectedIds.length) {
            setState((prev) => ({ ...prev, unmap_isOpen: true, selectedIds }));
        } else {
            notify('Please select event to unmap!!!', { type: 'warning' });
        }
    };

    const handleUnmapAll = (reason: string) => {
        handleClose();
        let data = params.data;
        let dataSelected = data.filter((x: IData) => selectedIds.find(y => y === x.id));
        if (dataSelected.length) {
            setState((prev) => ({ ...prev, unmap_sync_isLoading: true }));
            dataProvider.currentUser().then((user: IData) => {
                if (user.email) {
                    let iDelistModels = dataSelected.map((e: IData) => ({
                        eventId: e.id,
                        marketId: e.marketId,
                        by: user.email,
                        reasonTags: reason
                    }));
                    dataProvider.postData(params.resource, 'UnmapEvents', iDelistModels)
                        .then((response: IData) => {
                            if (response && response.data) {
                                if (response.data === true) {
                                    notify('All the events were unmapped!!!', { type: 'success' });
                                    setState((prev) => ({ ...prev, unmap_sync_isLoading: false }));
                                    reloadPage();
                                } else notify(`${response.data}`, { type: 'error' });
                            }
                        })
                        .catch((error: IData) => notify(`Error: ${error}`, { type: 'error' }));
                }
            });
        }
    };

    return (
        <>
            <Button variant="contained" size="small" onClick={confirmUnmapAll}>Unmap</Button>
            <AutocompleteConfirm
                isOpen={state.unmap_isOpen}
                title={`Are you sure to unmap all the selected (${state.selectedIds.length}) records?`}
                onClose={handleClose}
                onConfirm={(reason) => handleUnmapAll(reason)}
            />
            <MBackdrop isOpen={state.unmap_sync_isLoading} message={'Unmapping....'} />
        </>
    );
};

export default React.memo(UnmapAllButon);
